var _path, _rect, _rect2, _rect3, _path2, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 85,
    viewBox: "0 0 101 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 45H53C55.7614 45 58 42.7614 58 40V5C58 2.23858 55.7614 0 53 0H5C2.23858 7.08682e-07 2.01337e-08 2.23858 0 5V40C0 42.7614 2.23858 45 5 45H13V61.0859C13.0001 61.9767 14.0771 62.4228 14.707 61.793L31.5 45Z",
    fill: "#4D5975"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 5,
    rx: 2.5,
    transform: "matrix(-1 0 0 1 31 19)",
    fill: "#E6E7EB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 5,
    rx: 2.5,
    transform: "matrix(-1 0 0 1 45 9)",
    fill: "#E6E7EB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 5,
    rx: 2.5,
    transform: "matrix(-1 0 0 1 32 29)",
    fill: "#E6E7EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 67H48C45.2386 67 43 64.7614 43 62V27C43 24.2386 45.2386 22 48 22H96C98.7614 22 101 24.2386 101 27V62C101 64.7614 98.7614 67 96 67H88V83.0859C87.9999 83.9767 86.9229 84.4228 86.293 83.793L69.5 67Z",
    fill: "#C1C5CF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 31,
    width: 42,
    height: 5,
    rx: 2.5,
    fill: "#4D5975"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 41,
    width: 24,
    height: 5,
    rx: 2.5,
    fill: "#4D5975"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 51,
    width: 33,
    height: 5,
    rx: 2.5,
    fill: "#4D5975"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatColored);
export default __webpack_public_path__ + "static/media/ChatColored.4b965dda3dce7625580b1aad847cef98.svg";
export { ForwardRef as ReactComponent };